import { useAccount, useConnect, useDisconnect, useChainId, useSwitchChain } from 'wagmi'
import { optimism } from 'wagmi/chains'

export function ConnectWallet() {
  const { address, isConnected } = useAccount()
  const { connect, connectors, isPending } = useConnect()
  const { disconnect } = useDisconnect()
  const chainId = useChainId()
  const { switchChain, isPending: isSwitching } = useSwitchChain()

  const isWrongChain = isConnected && chainId !== optimism.id

  if (isConnected && isWrongChain) {
    return (
      <div className="connect-wallet">
        <div className="message message-warning">
          Wrong network. Please switch to Optimism.
        </div>
        <div className="flex gap-sm">
          <button
            onClick={() => switchChain({ chainId: optimism.id })}
            disabled={isSwitching}
            className="btn-primary"
          >
            {isSwitching ? 'Switching...' : 'Switch to Optimism'}
          </button>
          <button onClick={() => disconnect()} className="btn-secondary">
            Disconnect
          </button>
        </div>
      </div>
    )
  }

  if (isConnected) {
    return (
      <div className="connect-wallet connect-wallet-connected">
        <span className="connected-address">
          {address?.slice(0, 6)}...{address?.slice(-4)}
        </span>
        <button onClick={() => disconnect()} className="btn-secondary btn-small">
          Disconnect
        </button>
      </div>
    )
  }

  return (
    <div className="connect-wallet">
      <p className="text-muted">Connect wallet to distribute tokens</p>
      <div className="connector-buttons">
        {connectors.map((connector) => (
          <button
            key={connector.uid}
            onClick={() => connect({ connector })}
            disabled={isPending}
            className="btn-primary"
          >
            {connector.name}
          </button>
        ))}
      </div>
    </div>
  )
}
